<div class="label">
  <div layout layout-align-items-center>
    <rt-icon *ngIf="hasIcon" name="upgrade" size="small-x" margin-right-small-xx></rt-icon>
    <ng-content></ng-content>
  </div>
</div>
